interface InfoSlideProps {
  image: string
  title: string
}

export function InfoSlide({ image, title }: InfoSlideProps) {
  return (
    <div className="h-full flex flex-col items-center px-6 py-6 gap-6">
      {/* Screenshot - Takes remaining space */}
      <div className="flex-1 flex items-center justify-center min-h-0 w-full">
        <img
          src={image}
          alt={title}
          className="max-h-full max-w-full object-contain rounded-[var(--card-radius)] shadow-lg"
        />
      </div>

      {/* Text Content - Fixed height */}
      <div className="text-center max-w-md px-4 flex-shrink-0">
        <h2 className="text-xl font-bold text-foreground leading-tight">
          {title}
        </h2>
      </div>
    </div>
  )
}
